// src/primevue.js
import { createApp } from 'vue';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import "primeicons/primeicons.css"; // icons
import InputGroup from 'primevue/inputgroup';
import InputGroupAddon from 'primevue/inputgroupaddon';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import DataTable from 'primevue/datatable';
import Textarea from 'primevue/textarea';
import Column from 'primevue/column';
import ColumnGroup from 'primevue/columngroup'; // optional
import Row from 'primevue/row'; // optional
import Tag from 'primevue/tag';
import Card from 'primevue/card';
import Button from 'primevue/button';
import SplitButton from 'primevue/splitbutton';
import ToggleButton from 'primevue/togglebutton';
import Menubar from 'primevue/menubar';
import Menu from 'primevue/menu';
import InputMask from 'primevue/inputmask';
import Select from 'primevue/select';
import MultiSelect from 'primevue/multiselect';
import SelectButton from 'primevue/selectbutton';
import Toast from 'primevue/toast';
import Dialog from 'primevue/dialog';
import Chart from 'primevue/chart';
import Skeleton from 'primevue/skeleton';
import DatePicker from 'primevue/datepicker';
import Password from 'primevue/password';
import FocusTrap from 'primevue/focustrap';
import Breadcrumb from 'primevue/breadcrumb';
import Tooltip from 'primevue/tooltip';
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import TreeSelect from 'primevue/treeselect';
import ConfirmPopup from 'primevue/confirmpopup';
import Drawer from 'primevue/drawer';
import ToggleSwitch from 'primevue/toggleswitch';
import Checkbox from 'primevue/checkbox';
import ProgressSpinner from 'primevue/progressspinner';
import Stepper from 'primevue/stepper';
import StepList from 'primevue/steplist';
import StepPanels from 'primevue/steppanels';
import StepItem from 'primevue/stepitem';
import Step from 'primevue/step';
import StepPanel from 'primevue/steppanel';
import Divider from 'primevue/divider';
import ProgressBar from 'primevue/progressbar';
import ContextMenu from 'primevue/contextmenu';
import FileUpload from 'primevue/fileupload';



import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';



export default function setupPrimeVue(app) {
    app.use(PrimeVue, {
        theme: {
            preset: Aura,
            options: {
                prefix: 'p',
                darkModeSelector: '.p-dark',
                cssLayer: false,
            }
        }
    });

    app.directive('focustrap', FocusTrap);
    app.directive('tooltip', Tooltip);
    app.use(ToastService);
    app.use(ConfirmationService);
    
    app.component('IconField', IconField);
    app.component('InputIcon', InputIcon);
    app.component('InputText', InputText);
    app.component('InputNumber', InputNumber);
    app.component('Password', Password);
    app.component('Textarea', Textarea);
    app.component('DataTable', DataTable);
    app.component('Column', Column);
    app.component('ColumnGroup', ColumnGroup);
    app.component('Row', Row);
    app.component('Tag', Tag);
    app.component('Card', Card);
    app.component('Button', Button);
    app.component('SplitButton', SplitButton);
    app.component('Menubar', Menubar);
    app.component('Menu', Menu);
    app.component('InputGroup', InputGroup);
    app.component('InputGroupAddon', InputGroupAddon);
    app.component('InputMask', InputMask);
    app.component('Select', Select);
    app.component('MultiSelect', MultiSelect);
    app.component('TreeSelect', TreeSelect);
    app.component('SelectButton', SelectButton);
    app.component('Toast', Toast);
    app.component('Chart', Chart);
    app.component('Dialog', Dialog);
    app.component('Skeleton', Skeleton);
    app.component('DatePicker', DatePicker);
    app.component('ToggleButton', ToggleButton);
    app.component('Breadcrumb', Breadcrumb);
    app.component('Accordion', Accordion);
    app.component('AccordionPanel', AccordionPanel);
    app.component('AccordionHeader', AccordionHeader);
    app.component('AccordionContent', AccordionContent);
    app.component('ConfirmPopup', ConfirmPopup);
    app.component('Drawer', Drawer);
    app.component('ToggleSwitch', ToggleSwitch);
    app.component('Checkbox ', Checkbox );
    app.component('ProgressSpinner', ProgressSpinner);
    app.component('ProgressBar', ProgressBar);
    app.component('Stepper', Stepper);
    app.component('StepList', StepList);
    app.component('StepPanels', StepPanels);
    app.component('StepItem', StepItem);
    app.component('Step', Step);
    app.component('StepPanel', StepPanel);
    app.component('Divider', Divider);
    app.component('ContextMenu', ContextMenu);
    app.component('FileUpload', FileUpload);
}
